/* Jade v2 · Scent, CURTAINS. How it works: the headers of sections/jade-v2-scent.liquid and assets/jade-v2-scent.css.
   The motion is CSS. This file decides whether the deck goes live (JS on, motion allowed, no Save-Data, not 2g, the stylesheet applied),
   loads the three photographs when the section approaches and marks each ready once decoded, opens the places on arrival, once, in
   turn (the visitor's hand always wins), and reads hover, a tap on a place and a press on one of the three marks into one attribute,
   data-s (0, 1, 2), which the stylesheet turns into curtains. It never listens to scroll, wheel or touch moves. */
(function () {
  'use strict';
  var w = window, d = document, root = d.getElementById('d-scent');
  if (!root || !root.classList.contains('d-mod--scent')) return;

  function init() {
    var SSD = w.SSD, conn = navigator.connection || {};
    if (root.classList.contains('d-sc--live')) return;
    if (!SSD || SSD.reduced || conn.saveData || /^(slow-2g|2g)$/.test(conn.effectiveType || '') || !w.IntersectionObserver) return;
    if (/[?&]jv2reduce=1/.test(location.search) || w.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!(SSD.animated || d.documentElement.classList.contains('d-anim'))) return;
    if (!(w.CSS && CSS.supports && CSS.supports('translate', '0 0'))) return;                  // the curtains move with the standalone translate property (Chrome 104, Safari 14.1): older browsers keep the static panels
    var deck = root.querySelector('.d-sc-deck'), arts = [].slice.call(root.querySelectorAll('.d-sc-k')),
      marks = [].slice.call(root.querySelectorAll('.d-sc-b')), wide = w.matchMedia('(min-width: 900px)'),
      FIRST = 3000, HOLD = 3400,                      // ms each place is held before the next opens: the first (after the photographs are ready), then the second
      o = 0, g = 0,                                    // an open place's share of the deck and a closed place's sliver (%): read from the stylesheet's --o and --g
      s = 0, auto = false, held = false, inview = false, ready = 0, started = false, timer = 0, hov = 0, idle = 0, fallback = 0, warmed = false, px = -1, py = -1;
    if (!deck || arts.length !== 3) return;

    function set(n) {
      s = n; root.setAttribute('data-s', n);
      marks.forEach(function (b, i) { b.setAttribute('aria-pressed', i === n ? 'true' : 'false'); });
    }
    function user(n) { started = true; auto = false; clearTimeout(timer); set(n); }   // a hand on the deck ends the sequence for good, and it never starts after

    // the sequence: the first place is open; after FIRST the second, after HOLD more the third. Held while the pointer is on the deck or the deck is off screen.
    function sched(ms) {
      clearTimeout(timer);
      if (!auto || held || !inview) return;
      timer = setTimeout(function () { if (!auto || s >= 2) { auto = false; return; } set(s + 1); if (s < 2) sched(HOLD); else auto = false; }, ms);
    }
    function begin() { if (started) return; started = true; auto = true; sched(FIRST); }

    // each photograph shows only once decoded (until then the place's colour stands in)
    function warm() {
      if (warmed) return; warmed = true;
      arts.forEach(function (a) {
        var im = a.querySelector('.d-sc-img'), fin = false;
        function done() { if (fin) return; fin = true; a.classList.add('d-ok'); if (++ready === 3 && inview) begin(); }
        if (!im) return done();
        im.setAttribute('loading', 'eager');
        function ok() { (im.decode ? im.decode() : Promise.resolve()).then(done, done); }
        if (im.complete && im.naturalWidth) ok(); else { im.addEventListener('load', ok); im.addEventListener('error', done); }
      });
    }

    function shares() { var cs = w.getComputedStyle(root); o = parseFloat(cs.getPropertyValue('--o')) || 76; g = parseFloat(cs.getPropertyValue('--g')) || 12; }
    function region(x, y) {                                              // which place is under a point, given the curtains where they are now
      var r = deck.getBoundingClientRect(), u = (wide.matches ? (x - r.left) / r.width : (y - r.top) / r.height) * 100,
        c1 = s === 0 ? o : g, c2 = s === 2 ? 2 * g : o + g;               // where curtain 2 and 3 start with place s open (the stylesheet's numbers)
      return u >= c2 ? 2 : u >= c1 ? 1 : 0;
    }

    function live() {
      if (root.classList.contains('d-sc--live')) return;
      if (root.getBoundingClientRect().bottom < 0) return;                // a late stylesheet: the reader is already past it, and going live would shrink the page above them
      root.classList.add('d-sc--live'); set(0); shares();
      if (wide.addEventListener) wide.addEventListener('change', shares);
      new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) warm(); }, { rootMargin: '300% 0px' }).observe(root);
      new IntersectionObserver(function (es) {                           // on screen: begin (once the photographs are ready, or after 4 s regardless), or pick the sequence up again
        var e = es[es.length - 1];
        inview = e.isIntersecting && e.intersectionRect.height >= Math.min(e.boundingClientRect.height * 0.6, w.innerHeight * 0.5);
        if (inview) { warm(); if (!started) { if (ready === 3) begin(); else if (!fallback) fallback = setTimeout(begin, 4000); } else if (auto) sched(1200); }
        else clearTimeout(timer);
      }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] }).observe(deck);
      marks.forEach(function (b) { b.addEventListener('click', function () { user(+b.getAttribute('data-go')); }); });
      deck.addEventListener('click', function (e) { var n = region(e.clientX, e.clientY); if (n !== s) user(n); });
      if (w.matchMedia('(hover: hover) and (pointer: fine)').matches) {   // a mouse: rest on a place to open it; the sequence waits while the mouse is moving over the deck
        function real(e) {                                               // a move of 6 px or more since the last one; the browser's own hover refresh after a scroll does not count
          var was = px >= 0, far = Math.abs(e.clientX - px) + Math.abs(e.clientY - py) >= 6;
          if (!was || far) { px = e.clientX; py = e.clientY; }
          return was && far;
        }
        deck.addEventListener('pointerleave', function () { px = -1; held = false; clearTimeout(hov); clearTimeout(idle); if (auto) sched(1500); });
        deck.addEventListener('pointermove', function (e) {
          if (e.pointerType !== 'mouse' || !real(e)) return;
          held = true; clearTimeout(timer); clearTimeout(idle);
          idle = setTimeout(function () { held = false; if (auto) sched(1500); }, 2500);
          var n = region(e.clientX, e.clientY); clearTimeout(hov);
          if (n !== s) hov = setTimeout(function () { user(n); }, 160);
        });
      }
      w.__dSc = function (n) { user(n); return s; };                      // QA: open place n
    }

    var tries = 0;
    (function poll() {                                                   // the deferred stylesheet is applied once its token reads
      if ((w.getComputedStyle(root).getPropertyValue('--sc-ok') || '').trim() !== '') live();
      else if (++tries < 120) setTimeout(poll, 125);
    })();
  }

  if (w.SSD && w.SSD.onReady) w.SSD.onReady(init);
})();
